import styled from '@emotion/styled';
import { getColor } from '../../utils/index.ts';
import { Card } from '../Card/index.tsx';
import { EmotionContainerViewProps } from './types.ts';

export const Container = styled(Card)<EmotionContainerViewProps>`
  box-shadow: ${getColor('gray-deep-2')} 0px 4px 8px;
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}px;` : '')}
`;
